import React, { useEffect } from "react";
import { ScrollToTop } from "../components/ScrollToTop";

const ShippingPolicy = () => {
  useEffect(() => {
    
  }, []);
  return (
    <div className="max-w-4xl mx-auto p-6 font-sans text-black">
      <h1 className="text-2xl font-bold">SHIPPING & DELIVERY POLICY</h1>
      <p className="mt-2">Last updated September 27, 2024</p>

      <p className="mt-4">
        This Shipping & Delivery Policy is part of our Terms and Conditions
        ("Terms") and should therefore be read alongside our main Terms:
        <a
          href="https://sairahjewels.com/terms-and-conditions.html"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          https://sairahjewels.com/terms-and-conditions.html
        </a>
        .
      </p>

      <p className="mt-4">
        Please carefully review our Shipping & Delivery Policy when purchasing
        our products. This policy will apply to any order you place with us.
      </p>

      <h1 className="text-2xl font-bold mt-6">
        WHAT ARE MY SHIPPING & DELIVERY OPTIONS?
      </h1>

      <h2 className="text-xl font-semibold mt-4">In-Store Pickup</h2>
      <p className="mt-2">
        In-store and curbside pickup is available for all purchases. Pickups are
        available Monday to Friday, 10 am to 5 pm.
      </p>

      <p className="mt-4">
        We offer various shipping options. In some cases, a third-party supplier
        may be managing our inventory and will be responsible for shipping your
        products.
      </p>

      <h2 className="text-xl font-semibold mt-4">Free Shipping</h2>
      <p className="mt-2">
        We offer free Standard shipping on all domestic orders.
      </p>

      <p className="mt-2">
        Once your order is placed, you can see the step-by-step progress of your
        order in the track orders section under your profile.
      </p>

      <h1 className="text-2xl font-bold mt-6">
        DO YOU DELIVER INTERNATIONALLY?
      </h1>
      <p className="mt-2">
        We offer worldwide shipping. Free Standard shipping is not valid on
        international orders.
      </p>

      <p className="mt-4">
        Please note, we may be subject to various rules and restrictions in
        relation to some international deliveries and you may be subject to
        additional taxes and duties over which we have no control. If such cases
        apply, you are responsible for complying with the laws applicable to the
        country where you live and will be responsible for any such additional
        costs or taxes.
      </p>

      <h2 className="text-xl font-semibold mt-4">
        WHAT HAPPENS IF MY ORDER IS DELAYED?
      </h2>
      <p className="mt-2">
        If delivery is delayed for any reason, we will let you know as soon as
        possible and will advise you of a revised estimated date for delivery.
      </p>

      <p className="mt-2">
        For EU and UK consumers: This does not affect your statutory rights. For
        more information, please refer to our Terms.
      </p>

      <h1 className="text-2xl font-bold mt-6">QUESTIONS ABOUT RETURNS?</h1>
      <p className="mt-2">
        If you have questions about returns, please review our Return Policy:
        <a
          href="https://sairahjewels.com/retum- and-refund.html"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline ml-1"
        >
          https://sairahjewels.com/retum- and-refund.html
        </a>
      </p>

      <h1 className="text-2xl font-bold mt-6">
        HOW CAN YOU CONTACT US ABOUT THIS POLICY?
      </h1>
      <p className="mt-2">
        If you have any further questions or comments, you may contact us by:
      </p>
      <p className="mt-2">Phone (Toll free): +91 88288 26996</p>
      <p className="mt-2">
        Email:{" "}
        <a
          href="mailto:support@sairahjewels.com"
          className="text-blue-600 underline"
        >
          support@sairahjewels.com
        </a>
      </p>
    </div>
  );
};

export default ShippingPolicy;
